import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

import { TranslateModule } from '@ngx-translate/core';

import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyWrapModule } from '@vendasta/galaxy/galaxy-wrap';
import { GalaxyTooltipModule } from '@vendasta/galaxy/tooltip';

import { DynamicComponentDialogComponent } from './dynamic-component-dialog/dynamic-component-dialog.component';
import { DynamicComponentSelectorComponent } from './dynamic-component-selector.component';

import {
  DynamicComponentSelectorService,
  Option,
  VariableMenuItem,
  VariableMenuItemOptions,
} from './dynamic-component-selector.service';
import { EmailUII18nModule } from '../../../../src/lib/i18n/email-ui-i18n.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';

export { DynamicComponentSelectorService, VariableMenuItemOptions, VariableMenuItem, Option };

@NgModule({
  providers: [DynamicComponentSelectorService],
  declarations: [DynamicComponentSelectorComponent, DynamicComponentDialogComponent],
  imports: [
    CommonModule,
    GalaxyTooltipModule,
    GalaxyWrapModule,
    MatFormFieldModule,
    MatButtonModule,
    MatDialogModule,
    MatInputModule,
    MatListModule,
    MatIconModule,
    MatTooltipModule,
    MatCardModule,
    MatOptionModule,
    TranslateModule,
    MatSelectModule,
    GalaxyEmptyStateModule,
    EmailUII18nModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocomplete,
    GalaxyFormFieldModule,
    MatAutocompleteTrigger,
  ],
  exports: [DynamicComponentSelectorComponent],
})
export class DynamicComponentSelectorModule {}
